// Detect whether the app is running inside a social / email in-app browser
// (Gmail, Facebook, Instagram, etc.) rather than a real browser tab. These
// embedded webviews frequently block or fail the Geolocation API, which stops
// workers from clocking in/out even when their device location is on.

const APP_TOKENS = [
  { re: /(FBAN|FBAV|FB_IAB|FBIOS|FBDV)/i, name: "Facebook" },
  { re: /Instagram/i, name: "Instagram" },
  { re: /Messenger/i, name: "Messenger" },
  { re: /\bLine\//i, name: "LINE" },
  { re: /(Twitter|TwitterAndroid)/i, name: "X (Twitter)" },
  { re: /WhatsApp/i, name: "WhatsApp" },
  { re: /Snapchat/i, name: "Snapchat" },
  { re: /LinkedInApp/i, name: "LinkedIn" },
  { re: /Pinterest/i, name: "Pinterest" },
  { re: /MicroMessenger/i, name: "WeChat" },
  { re: /(TikTok|musical_ly|BytedanceWebview)/i, name: "TikTok" },
  { re: /(Outlook-iOS|Outlook-Android)/i, name: "Outlook" },
  { re: /\bGSA\//i, name: "the Google app" },
];

export function detectInApp() {
  if (typeof navigator === "undefined") return { inApp: false, app: null };
  const ua = navigator.userAgent || "";

  for (const t of APP_TOKENS) if (t.re.test(ua)) return { inApp: true, app: t.name };

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  // iOS: a real tab (or SFSafariViewController, which supports geolocation)
  // reports "Safari"/CriOS/FxiOS. A bare WKWebView in-app browser (e.g. Gmail's)
  // usually has none of these tokens.
  if (isIOS && !/Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua)) {
    return { inApp: true, app: "an in-app browser" };
  }
  // Android WebView is flagged with "; wv" in the user agent.
  if (isAndroid && /;\s*wv[);]/i.test(ua)) {
    return { inApp: true, app: "an in-app browser" };
  }
  return { inApp: false, app: null };
}
